<h2 *ngIf="authorized">Granska ansökan</h2>
<h2 *ngIf="!authorized">Granska och skriv ut ansökan</h2>
<app-form-group>
    <ng-container *ngIf="iapplicant">
        <label class="text-standard" for="contact-info">{{getLabel('contact-info')}}</label>
        <ul id="contact-info">
            <li *ngIf="ssn">Personnummer: {{ssn}}</li>
            <li *ngIf="iapplicant.applicantAddress">Adress: {{iapplicant.applicantAddress}}</li>
            <li *ngIf="iapplicant.applicantPhone">Telefon: {{iapplicant.applicantPhone}}</li>
        </ul>
    </ng-container>

    <ng-container *ngIf="examinas">
        <label class="text-standard" for="degree">{{getLabel('degree')}}</label>
        <ul id="degree">
            <li *ngFor="let examina of examinas">{{examina.name}}, examensår {{examina.year}}</li>
        </ul>
    </ng-container>

    <label class="text-standard" for="special-education">{{getLabel('special-education')}}</label>
    <ul id="special-education">
        <li *ngIf="isSpecialEducationTeacher">Jag har en speciallärarexamen och ansöker om behörighet</li>
        <li *ngIf="!isSpecialEducationTeacher">Jag har ingen speciallärarexamen</li>
    </ul>

    <ng-container *ngIf="vocationalQualifications.length > 0">
        <label class="text-standard" for="vocational-qualification">{{getLabel('vocational-qualification')}}</label>
        <ul id="vocational-qualification">
            <li *ngFor="let qualification of vocationalQualifications">{{qualification.qual}}
                <ul>
                    <li *ngFor="let basis of qualification.bases">{{basis}}</li>
                </ul>
            </li>
        </ul>
    </ng-container>

    <ng-container *ngIf="otherQualifications.length > 0">
        <label class="text-standard" for="other-qualification">{{getLabel('other-qualification')}}</label>
        <ul id="other-qualification">
            <li *ngFor="let qualification of otherQualifications">{{qualification.qual}}
                <ul>
                    <li *ngFor="let basis of qualification.bases">{{basis}}</li>
                </ul>
            </li>
        </ul>
    </ng-container>

    <ng-container *ngIf="attachments.length > 0 || deliveryMethod">
        <label class="text-standard" for="attachment">{{getLabel('attachment')}}</label>
        <ul id="attachment">
            <li *ngIf="deliveryMethod">Jag har valt att {{deliveryMethod}}</li>
            <li *ngFor="let att of attachments">{{att.name}} ({{att.size}})</li>
        </ul>
    </ng-container>

    <label class="text-standard" for="payment">Betalning</label>
    <ul id="payment">
        <li *ngIf="payment">Ansökningsavgiften är {{payment}} kr</li>
        <li *ngIf="!payment">Baserat på de uppgifter som du har lämnat behöver Skolverket granska din examen innan vi
            kan
            besluta om du ska betala en ansökningsavgift</li>
    </ul>
</app-form-group>

<ng-container *ngIf="authorized then confirm; else print"></ng-container>
<ng-template #confirm>
    <app-form-group>
        <app-checkbox [control]="confirmationControl">
            Jag försäkrar på heder och samvete att uppgifterna i denna ansökan och i samtliga bifogade dokument är sanna
        </app-checkbox>
    </app-form-group>
    <app-form-group>
        <span *ngIf="qualificationError" class="text-error text-small">{{qualificationError}}</span>
    </app-form-group>
</ng-template>
<ng-template #print>
    <app-form-group>
        <h2>Skriv ut din ansökan och skicka per post tillsammans med bilagor</h2>
        <ul style="list-style: decimal; padding-inline-start: 15px;">
            <li>Skriv ut din ansökan</li>
            <li>Skriv under ansökan</li>
            <li>Posta in ansökan tillsammans med bilagor till Skolverket. Vänligen häfta ej ihop ansökan, eftersom det
                försvårar hanteringen av dina dokument.</li>
        </ul>
        <label class="text-standard" for="address">Postadress:</label>
        <ul id="address" style="list-style: none; padding: 0;">
            <li><b>Skolverket</b></li>
            <li><b>Box 4002</b></li>
            <li><b>171 04 Solna</b></li>
        </ul>
    </app-form-group>
    <app-form-group>
        <button class="btn btn--secondary" type="button" data-test-id="print-button" (click)="generateDocument()">Ladda ner och skriv ut</button>
    </app-form-group>
</ng-template>
